import React, { useEffect } from 'react'
import Layout from '../../components/layout'
import SEO from '../../components/seo'
import { graphql } from 'gatsby'
import ResourceType from '../../components/resource-type'
import GravityForm from '../../components/gravity-form'
import useQueryParam from '../../hooks/useQueryParam'

interface LocationState {
  email: string
}
interface Location {
  state?: LocationState
}
interface Props {
  location?: Location
  data: any
}

export const postAltData = graphql`
  query getAltPost($id: String, $gravityFormId: Int) {
    post: wpContentNode(id: { eq: $id }) {
      ... on WpTool {
        id
        content
        date(formatString: "MMMM DD YYYY")
        nodeType
        slug
        title
        link
        uri
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        categories {
          nodes {
            name
          }
        }
        seo {
          canonical
          title
          metaDesc
          focuskw
          metaKeywords
          metaRobotsNoindex
          metaRobotsNofollow
          opengraphAuthor
          opengraphDescription
          opengraphTitle
          opengraphDescription
          opengraphImage {
            altText
            sourceUrl
            srcSet
          }
          opengraphUrl
          opengraphSiteName
          opengraphPublishedTime
          opengraphModifiedTime
          twitterTitle
          twitterDescription
          twitterImage {
            altText
            sourceUrl
            srcSet
          }
          breadcrumbs {
            url
            text
          }
          cornerstone
          schema {
            pageType
            articleType
            raw
          }
        }
        acfHubspotForm {
          hubspotFormTitle
          hubspotFormButtonClass
          gravityFormEnabled
          gravityFormId
          pardotFormHandlerUrl
          redirectUrl
          gravityFormInputCssClasses
          gravityFormLabelCssClasses
          gravityFormButtonText
          gravityFormButtonCssClasses
        }
      }
      ... on WpWebinar {
        id
        content
        date(formatString: "MMMM DD YYYY")
        nodeType
        slug
        title
        link
        uri
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        categories {
          nodes {
            name
          }
        }
        seo {
          canonical
          title
          metaDesc
          focuskw
          metaKeywords
          metaRobotsNoindex
          metaRobotsNofollow
          opengraphAuthor
          opengraphDescription
          opengraphTitle
          opengraphDescription
          opengraphImage {
            altText
            sourceUrl
            srcSet
          }
          opengraphUrl
          opengraphSiteName
          opengraphPublishedTime
          opengraphModifiedTime
          twitterTitle
          twitterDescription
          twitterImage {
            altText
            sourceUrl
            srcSet
          }
          breadcrumbs {
            url
            text
          }
          cornerstone
          schema {
            pageType
            articleType
            raw
          }
        }
        acfHubspotForm {
          hubspotFormTitle
          hubspotFormButtonClass
          gravityFormEnabled
          gravityFormId
          pardotFormHandlerUrl
          redirectUrl
          gravityFormInputCssClasses
          gravityFormLabelCssClasses
          gravityFormButtonText
          gravityFormButtonCssClasses
        }
      }
      ... on WpWhitepaper {
        id
        content
        date(formatString: "MMMM DD YYYY")
        nodeType
        slug
        title
        link
        uri
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        categories {
          nodes {
            name
          }
        }
        seo {
          canonical
          title
          metaDesc
          focuskw
          metaKeywords
          metaRobotsNoindex
          metaRobotsNofollow
          opengraphAuthor
          opengraphDescription
          opengraphTitle
          opengraphDescription
          opengraphImage {
            altText
            sourceUrl
            srcSet
          }
          opengraphUrl
          opengraphSiteName
          opengraphPublishedTime
          opengraphModifiedTime
          twitterTitle
          twitterDescription
          twitterImage {
            altText
            sourceUrl
            srcSet
          }
          breadcrumbs {
            url
            text
          }
          cornerstone
          schema {
            pageType
            articleType
            raw
          }
        }
        acfHubspotForm {
          gravityFormEnabled
          gravityFormId
          pardotFormHandlerUrl
          redirectUrl
          gravityFormInputCssClasses
          gravityFormLabelCssClasses
          gravityFormButtonText
          gravityFormButtonCssClasses
        }
      }
    }
    form: wpGfForm(databaseId: { eq: $gravityFormId }) {
      ...GravityFormFields
    }
  }
`

const PostAlt: React.FC<Props> = ({ location, data }) => {
  const [pardotEmailQuery, setPardotEmailQueryParam] = useQueryParam('pi_list_email', '', true)
  const emailQueryParam = location?.state?.email ? location?.state?.email : ''

  useEffect(() => {
    if (emailQueryParam) {
      setPardotEmailQueryParam(emailQueryParam)
      window.location.reload()
    }
  }, [])

  const category = data?.post?.categories?.nodes[0]?.name

  const gravityFormId = data?.post?.acfHubspotForm?.gravityFormId
    ? data?.post?.acfHubspotForm?.gravityFormId
    : ''
  const gravityFormEnabled = data?.post?.acfHubspotForm?.gravityFormEnabled
    ? data?.post?.acfHubspotForm?.gravityFormEnabled
    : ''

  return (
    <Layout location={location} className={`post post-${data?.post?.nodeType?.toLowerCase()}`}>
      <SEO
        seo={data?.post?.seo}
        url={data?.post?.link}
        featuredImage={data?.post?.featuredImage?.node?.sourceUrl}
        isBlogPost={true}
      />
      <div className='content-single max-w-screen-2xl mx-auto'>
        <div className='content-single__main overflow-hidden p-12'>
          <div className='body-5 text-gray-silver mb-5'>
            <ResourceType resource={data?.post?.nodeType} /> — <span>{category}</span>
          </div>
          <h1>{data?.post?.title}</h1>
          <div className='text-gray' dangerouslySetInnerHTML={{ __html: data?.post?.content }} />
        </div>
        <div className='content-single__sidebar bg-blue-tint py-10 px-12 mr-12'>
          {gravityFormEnabled && gravityFormId ? <div id='gForm'></div> : ''}
        </div>
      </div>
      {gravityFormEnabled && gravityFormId ? (
        <GravityForm
          portalRef='gForm'
          formPageSettings={data?.post?.acfHubspotForm}
          form={data?.form}
        />
      ) : (
        ''
      )}
    </Layout>
  )
}

export default PostAlt
